import { render, staticRenderFns } from "./DocumentCount.vue?vue&type=template&id=b3bdae08&"
import script from "./DocumentCount.vue?vue&type=script&lang=js&"
export * from "./DocumentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports